module.exports = __webpack_public_path__ + "static/img/17018B_1_R_20200921_LC.82456c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17018B_1_R_20200921_LC.png
// module id = ey/C
// module chunks = 0